import { LoanAppTask } from '../../shared/models/index';

export class SvgIconUtils {
  static MASTER_SVG_FILE_PATH = 'assets/svgs/svgs.svg';

  static appendDefaultToIconPath(iconPath: string): string {
    return SvgIconUtils.MASTER_SVG_FILE_PATH + '#' + iconPath;
  }

  static get lightBulbIconPath(): string {
    return SvgIconUtils.appendDefaultToIconPath('icon-light-bulb');
  }

  static get collapseWidgetIcon(): string {
    return SvgIconUtils.appendDefaultToIconPath('icon-arrow-up');
  }

  static get phoneIconPath(): string {
    return SvgIconUtils.appendDefaultToIconPath('icon-phone');
  }

  static get emailIconPath(): string {
    return SvgIconUtils.appendDefaultToIconPath('icon-email');
  }

  static get clockIconPath(): string {
    return SvgIconUtils.appendDefaultToIconPath('icon-clock');
  }

  static get lockIconPath(): string {
    return SvgIconUtils.appendDefaultToIconPath('icon-lock');
  }

  static get checkMarkPath(): string {
    return SvgIconUtils.appendDefaultToIconPath('icon-step-check');
  }

  static getTaskIcon(type: LoanAppTask.TypeEnum): string {
    let iconName: string = '';
    switch (type) {
      case LoanAppTask.TypeEnum.UploadDocument:
        iconName = 'icon-upload';
        break;
      case LoanAppTask.TypeEnum.SubmitLoanApplication:
        iconName = 'icon-lock';
        break;
      case LoanAppTask.TypeEnum.VerifyEmail:
        iconName = 'icon-send';
        break;
      case LoanAppTask.TypeEnum.LinkBankAccount:
      case LoanAppTask.TypeEnum.FundingDocs:
        iconName = 'icon-link';
        break;
      case LoanAppTask.TypeEnum.SignLoanPacket:
        iconName = 'icon-sign-loan-packet';
        break;
      case LoanAppTask.TypeEnum.Declined:
        iconName = 'magnifying-glass-zoom-in';
        break;
      case LoanAppTask.TypeEnum.ReapplyNow:
        iconName = 'icon-redo';
        break;
      case LoanAppTask.TypeEnum.ValidateTrialDeposit:
        iconName = 'icon-checkmark';
        break;
    }

    // If there is not a case for the task type given, don't prepend the svg file path to the empty string.
    return !!iconName ? SvgIconUtils.appendDefaultToIconPath(iconName) : '';
  }
}
